import { BillType } from "@remi/enums/bill-type";
import { TaskStatus } from "@remi/enums/task-status";
import { TaskType } from "@remi/enums/task-type";

import { hasCapability, type User } from "../base";
import { NON_EXISTENT_ID } from "../utils/types";

export const billWhere = (user: User) => {
  if (hasCapability(user, "bill.read.all")) {
    return { deletedAt: null };
  }

  // bill.read.own semantically grants "bills your org is the payee on OR
  // bills you created". Splitting this into separate bill.read.org and
  // bill.read.owned capabilities would let scopes be granted independently,
  // but today the only role with this access is CONTRACTOR_ADMIN which
  // gets both conditions together. Out of scope for BONES-185.
  if (hasCapability(user, "bill.read.own")) {
    return {
      deletedAt: null,
      OR: [{ payeeId: user.person.organizationId }, { createdById: user.person.id }],
    };
  }

  return { deletedAt: null, AND: [{ id: NON_EXISTENT_ID }] };
};

export const bill = {
  create: (user: User) => hasCapability(user, "bill.create"),
  read: (user: User) => hasCapability(user, "bill.read") || hasCapability(user, "bill.read.own"),
  readAll: (user: User) => hasCapability(user, "bill.read.all"),
  delete: ({
    user,
    tasks,
    billType,
  }: {
    user: User;
    tasks: { type: TaskType; status: TaskStatus }[];
    billType: BillType;
  }) => {
    if (hasCapability(user, "bill.delete")) {
      return true;
    }

    const isProjectFinancialsFinalized = tasks.some(
      (task) => task.type === TaskType.VERIFY_CONTRACTOR_COSTS && task.status === TaskStatus.COMPLETED,
    );

    if (billType === BillType.MATERIALS && !isProjectFinancialsFinalized && hasCapability(user, "bill.create")) {
      return true;
    }

    return false;
  },
};

export const billReview = {
  create: (user: User) => hasCapability(user, "billReview.create"),
};
